export const ROLE_GET_MENU_LIST_BEGIN = 'ROLE_GET_MENU_LIST_BEGIN';
export const ROLE_GET_MENU_LIST_SUCCESS = 'ROLE_GET_MENU_LIST_SUCCESS';
export const ROLE_GET_MENU_LIST_FAILURE = 'ROLE_GET_MENU_LIST_FAILURE';
export const ROLE_GET_MENU_LIST_DISMISS_ERROR = 'ROLE_GET_MENU_LIST_DISMISS_ERROR';
export const ROLE_SUBMIT_MENU_BEGIN = 'ROLE_SUBMIT_MENU_BEGIN';
export const ROLE_SUBMIT_MENU_SUCCESS = 'ROLE_SUBMIT_MENU_SUCCESS';
export const ROLE_SUBMIT_MENU_FAILURE = 'ROLE_SUBMIT_MENU_FAILURE';
export const ROLE_SUBMIT_MENU_DISMISS_ERROR = 'ROLE_SUBMIT_MENU_DISMISS_ERROR';
export const ROLE_DELETE_MENU_BEGIN = 'ROLE_DELETE_MENU_BEGIN';
export const ROLE_DELETE_MENU_SUCCESS = 'ROLE_DELETE_MENU_SUCCESS';
export const ROLE_DELETE_MENU_FAILURE = 'ROLE_DELETE_MENU_FAILURE';
export const ROLE_DELETE_MENU_DISMISS_ERROR = 'ROLE_DELETE_MENU_DISMISS_ERROR';
export const ROLE_MENU_MODAL_CHANGE = 'ROLE_MENU_MODAL_CHANGE';
export const ROLE_CHOOSE_CURRENT_MENU = 'ROLE_CHOOSE_CURRENT_MENU';
export const ROLE_GET_MENU_TREE_BEGIN = 'ROLE_GET_MENU_TREE_BEGIN';
export const ROLE_GET_MENU_TREE_SUCCESS = 'ROLE_GET_MENU_TREE_SUCCESS';
export const ROLE_GET_MENU_TREE_FAILURE = 'ROLE_GET_MENU_TREE_FAILURE';
export const ROLE_GET_MENU_TREE_DISMISS_ERROR = 'ROLE_GET_MENU_TREE_DISMISS_ERROR';
export const ROLE_GET_ROLE_LIST_BEGIN = 'ROLE_GET_ROLE_LIST_BEGIN';
export const ROLE_GET_ROLE_LIST_SUCCESS = 'ROLE_GET_ROLE_LIST_SUCCESS';
export const ROLE_GET_ROLE_LIST_FAILURE = 'ROLE_GET_ROLE_LIST_FAILURE';
export const ROLE_GET_ROLE_LIST_DISMISS_ERROR = 'ROLE_GET_ROLE_LIST_DISMISS_ERROR';
export const ROLE_SUBMIT_ROLE_BEGIN = 'ROLE_SUBMIT_ROLE_BEGIN';
export const ROLE_SUBMIT_ROLE_SUCCESS = 'ROLE_SUBMIT_ROLE_SUCCESS';
export const ROLE_SUBMIT_ROLE_FAILURE = 'ROLE_SUBMIT_ROLE_FAILURE';
export const ROLE_SUBMIT_ROLE_DISMISS_ERROR = 'ROLE_SUBMIT_ROLE_DISMISS_ERROR';
export const ROLE_DELETE_ROLE_BEGIN = 'ROLE_DELETE_ROLE_BEGIN';
export const ROLE_DELETE_ROLE_SUCCESS = 'ROLE_DELETE_ROLE_SUCCESS';
export const ROLE_DELETE_ROLE_FAILURE = 'ROLE_DELETE_ROLE_FAILURE';
export const ROLE_DELETE_ROLE_DISMISS_ERROR = 'ROLE_DELETE_ROLE_DISMISS_ERROR';
export const ROLE_ROLE_MODAL_CHANGE = 'ROLE_ROLE_MODAL_CHANGE';
export const ROLE_CHOOSE_CURRENT_ROLE = 'ROLE_CHOOSE_CURRENT_ROLE';
export const ROLE_ON_CHECK_KEYS = 'ROLE_ON_CHECK_KEYS';
export const ROLE_SAVE_ROLE_MENU_BEGIN = 'ROLE_SAVE_ROLE_MENU_BEGIN';
export const ROLE_SAVE_ROLE_MENU_SUCCESS = 'ROLE_SAVE_ROLE_MENU_SUCCESS';
export const ROLE_SAVE_ROLE_MENU_FAILURE = 'ROLE_SAVE_ROLE_MENU_FAILURE';
export const ROLE_SAVE_ROLE_MENU_DISMISS_ERROR = 'ROLE_SAVE_ROLE_MENU_DISMISS_ERROR';
export const ROLE_GET_ROLE_MENU_BEGIN = 'ROLE_GET_ROLE_MENU_BEGIN';
export const ROLE_GET_ROLE_MENU_SUCCESS = 'ROLE_GET_ROLE_MENU_SUCCESS';
export const ROLE_GET_ROLE_MENU_FAILURE = 'ROLE_GET_ROLE_MENU_FAILURE';
export const ROLE_GET_ROLE_MENU_DISMISS_ERROR = 'ROLE_GET_ROLE_MENU_DISMISS_ERROR';
export const ROLE_GET_ALL_ROLE_BEGIN = 'ROLE_GET_ALL_ROLE_BEGIN';
export const ROLE_GET_ALL_ROLE_SUCCESS = 'ROLE_GET_ALL_ROLE_SUCCESS';
export const ROLE_GET_ALL_ROLE_FAILURE = 'ROLE_GET_ALL_ROLE_FAILURE';
export const ROLE_GET_ALL_ROLE_DISMISS_ERROR = 'ROLE_GET_ALL_ROLE_DISMISS_ERROR';





// WEBPACK FOOTER //
// ./src/features/role/redux/constants.js